import { createAction } from '@reduxjs/toolkit';
import * as types from './type';
import axiosAdapter from '../../../utils/Adapters';
import { CMSAPI_INDEX } from '../../../utils/CmsAPI';
import config from '../../../config';

const reset = createAction(types.ACTION_RESET);
const requestFetch = createAction(types.ACTION_REQUEST);
const receiveSuccess = createAction(types.ACTION_SUCCESS);
const receiveError = createAction(types.ACTION_ERROR);

const massageData = (response, getTotal) => {
  if (getTotal) {
    return {
      total: response.data.total,
      result: response.data.result.assets.map((v) => {
        const { content, metadata, ...rest } = v;
        return {
          ...rest,
          topMetadata: metadata,
          ...v.content.content,
        };
      }),
    };
  } else {
    return response.data.result.assets.map((v) => {
      const { content, metadata, ...rest } = v;
      return {
        ...rest,
        topMetadata: metadata,
        ...v.content.content,
      };
    });
  }

  // const responseData = response.data;
  // const data = responseData.result.assets;
  // if (!data) {
  //   throw new Error('no data');
  // }
  // return data;
};

const messageError = (error) => {
  const message =
    ((((error || {}).response || {}).data || {}).error || {}).message || error.message;
  return message;
};

const fetchDataIndex = (
  pathName,
  pageType,
  qArray,
  sortBy,
  enableDate,
  start,
  max,
  custom_q,
  setApiTime,
) => {
  const q = [];
  if (pathName) {
    q.push(`Path:/${pathName}.xml`);
  }
  if (pageType) {
    q.push(`TeamSite/Templating/DCR/Type:${pageType}`);
  }
  if (qArray && Array.isArray(qArray)) {
    q.push(...qArray.filter((item) => item));
  }
  if (enableDate) {
    const dateTime = new Date().getTime();
    q.push(`onlineTime:<=${dateTime}`);
    q.push(`offlineTime:>=${dateTime}`);
  }
  const queryParameters = {
    sortBy,
    prefixPath: config.lscsPath,
    q: custom_q ? custom_q : q.map((v) => `(${v})`).join(' AND '),
    start,
    max,
    projectName: config.cmsProjectName,
    enableDate: false,
  };
  const url = CMSAPI_INDEX(queryParameters);

  {
    setApiTime && setApiTime({ startTime: new Date().getTime(), endTime: null });
  }

  return axiosAdapter({
    url,
  });
};

const resetDetailDataList = () => {
  return (dispatch) => {
    dispatch(reset());
  };
};

const getDetailDataList = (
  detailKey,
  pathName,
  pageType = config.pageType.staticPage,
  qArray = [],
  start = null,
  max = null,
  sortBy = '',
  enableDate = false,
  custom_q = null,
  setApiTime = null,
  getTotal = false,
) => {
  return (dispatch) => {
    window.onUrlChangeCallBack = null;
    dispatch(requestFetch({ key: detailKey, data: { detailKey, pageType } }));
    return fetchDataIndex(
      pathName,
      pageType,
      qArray,
      sortBy,
      enableDate,
      start,
      max,
      custom_q,
      setApiTime,
    )
      .then((response) => massageData(response, getTotal))
      .then((data) => {
        dispatch(receiveSuccess({ key: detailKey, data: data }));
        {
          setApiTime &&
            setApiTime((prev) => ({
              ...prev,
              endTime: new Date().getTime(),
            }));
        }
      })
      .catch((error) => {
        const message = messageError(error);
        dispatch(receiveError({ key: detailKey, data: message }));
      });
  };
};

export { getDetailDataList, resetDetailDataList };
